import { render, staticRenderFns } from "./CourseMultVideo.vue?vue&type=template&id=23bfc73d&scoped=true&"
import script from "./CourseMultVideo.vue?vue&type=script&lang=js&"
export * from "./CourseMultVideo.vue?vue&type=script&lang=js&"
import style0 from "./CourseMultVideo.vue?vue&type=style&index=0&id=23bfc73d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfc73d",
  null
  
)

export default component.exports